import React from 'react';
import { Button } from 'govuk-react-jsx/govuk/components/button';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import { setEmailCodeResent } from '../../features/registration/registrationJourneySlice';
import { resendCode } from '../../firebase';

const IncorrectVerificationCode = () => {
  const history = useHistory();
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;
  const dispatch = useDispatch();

  const handleBtnClick = () => {
    resendCode({ type: 'email' })
      .then(() => {
        dispatch(setEmailCodeResent(true));
        history.push('/landlordReg/check-email');
      })
      .catch(() => {
        // TODO: Show network error message
      });
  };

  const pageModel = (
    <>
      <h1 className="govuk-heading-xl">
        {copyProvider.getCopy(
          'landlordReg.IncorrectVerificationCode.s1',
          'Incorrect verification code'
        )}
      </h1>
      <p className="govuk-body paragraph-one">
        {copyProvider.getCopy(
          'landlordReg.IncorrectVerificationCode.s2',
          'The verification code you have entered is incorrect.'
        )}
      </p>
      <p className="govuk-body paragraph-two">
        {copyProvider.getCopy(
          'landlordReg.IncorrectVerificationCode.s3',
          'You will need to request a new code to continue. This code will be sent to the email address you have provided to us.'
        )}
      </p>

      <Button
        className="govuk-button govuk-!-margin-top-5"
        onClick={() => handleBtnClick()}
      >
        {copyProvider.getCopy(
          'landlordReg.IncorrectVerificationCode.s4',
          'Request a new code'
        )}
      </Button>
    </>
  );
  return pageModel;
};

export default IncorrectVerificationCode;
